<template>
  <div style="width: 100%">
    <div v-if="parent === ''" class="chart_button_wrap">
      <button type="button" class="active_date" :class="{ active: activePeriod === 'week1' }" @click="chartPeriodSet('week1')">1주일</button>
      <button type="button" class="active_date" :class="{ active: activePeriod === 'month1' }" @click="chartPeriodSet('month1')">1개월</button>
      <button type="button" class="active_date" :class="{ active: activePeriod === 'month3' }" @click="chartPeriodSet('month3')">3개월</button>
      <button type="button" class="active_date" :class="{ active: activePeriod === 'month6' }" @click="chartPeriodSet('month6')">6개월</button>
      <button type="button" class="active_date" :class="{ active: activePeriod === 'year1' }" @click="chartPeriodSet('year1')">1년</button>
      <button type="button" class="active_date" :class="{ active: activePeriod === 'year2' }" @click="chartPeriodSet('year2')">2년</button>
    </div>
    <div class="line_bar_chart_wrap d-flex">
      <div class="chart_box">
        <div :class="parent === 'report' ? 'wid1020' : `wid${chartWidth}`">
          <line-chart :key="updated + 1" :height="parent === 'report' ? 112 : 142" :chart-data="lineChartData.chartData" :options="lineChartData.options"></line-chart>
          <bar-chart :key="updated" class="bar_chart_box" :height="145" :chart-data="barChartData.chartData" :options="barChartData.options"></bar-chart>
        </div>
      </div>
      <div v-if="parent !== 'report'" class="chart_label_box">
        <div>
          <i class="color_box blue"></i>
          {{ healthStatus.S.text }}
        </div>
        <div>
          <i class="color_box green"></i>
          {{ healthStatus.G.text }}
        </div>
        <div>
          <i class="color_box yellow"></i>
          {{ healthStatus.A.text }}
        </div>
        <div>
          <i class="color_box red"></i>
          {{ healthStatus.D.text }}
        </div>
      </div>
      <div v-if="parent !== 'report'" class="chart_divider"></div>
    </div>
  </div>
</template>

<script>
import BarChart from '@/components/chart/BarChart';
import LineChart from '@/components/chart/LineChart';
import { mapState } from 'vuex';
export default {
  name: 'StatusLineBarChart',
  components: {
    LineChart,
    BarChart,
  },
  props: {
    daily: {
      type: Array,
      default: null,
    },
    parent: {
      type: String,
      default: '',
    },
    width: {
      type: Number,
      default: 1165,
    },
  },
  data: () => ({
    updated: 0,
    chartWidth: '',
    chartData: [],
    chartLabels: [],
    chartToolbarText: [],
    chartBarColors: [],
    activePeriod: '',
    lineChartData: {
      chartData: {
        labels: [],
        datasets: [
          {
            data: [],
            fill: false,
            borderColor: '#707070',
            borderWidth: 3,
            pointStyle: 'rect',
            pointBackgroundColor: '#000',
            pointRadius: 3,
            pointBorderColor: '#000',
            clip: { left: 0, top: false, right: 0, bottom: false },
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        spanGaps: false,
        layout: {
          padding: {
            top: 10,
          },
        },
        scales: {
          xAxes: [
            {
              offset: true,
              ticks: {
                display: false,
              },
              gridLines: {
                display: false,
                zeroLineColor: 'transparent',
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                // beginAtZero: true,
                display: false,
                max: 4,
                min: 1,
                maxTicksLimit: 4,
                stepSize: 1,
              },
              gridLines: {
                drawBorder: false,
              },
            },
          ],
        },
        legend: {
          display: false,
        },
        tooltips: {
          backgroundColor: '#202126',
          xPadding: 30,
          yPadding: 10,
          bodyFontSize: 14,
          displayColors: false,
          caretSize: 0,
        },
      },
    },
    barChartData: {
      chartData: {
        labels: [],
        datasets: [
          {
            data: [],
            backgroundColor: [],
            maxBarThickness: 36,
          },
        ],
      },
      options: {
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              ticks: {
                // offset: false,
                fontSize: 12,
                fontColor: '#656e81',
                minRotation: 0,
                // minRotation: 90,
              },
              gridLines: {
                display: false,
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                display: false,
              },
              gridLines: {
                display: false,
              },
            },
          ],
        },
        legend: {
          display: false,
        },
        tooltips: {
          backgroundColor: '#202126',
          xPadding: 30,
          yPadding: 10,
          bodyFontSize: 14,
          displayColors: false,
          caretSize: 0,
        },
        plugins: {
          datalabels: {
            display: false,
          },
        },
      },
    },
  }),
  computed: {
    ...mapState('commonValue', ['healthStatus']),
  },
  created() {
    this.daily.forEach(element => {
      this.chartLabels.push(element.day);
      // 데이터가 없을 떄 null로 삽입 (데이터 없을 떄 라인그래프가 안 생겨야함)
      if (!element.state) {
        this.chartData.push(null);
        this.chartToolbarText.push(null);
        this.chartBarColors.push('#000');
      } else {
        this.chartData.push(this.healthStatus[element.state].value);
        this.chartToolbarText.push(this.healthStatus[element.state].text);
        this.chartBarColors.push(this.healthStatus[element.state].color);
      }
    });
    if (this.parent === 'statistics') {
      this.chartDataSet();
    } else {
      this.chartDataSet(7);
    }

    this.activePeriod = 'week1';
  },
  methods: {
    chartPeriodSet(period) {
      this.activePeriod = period;
      switch (period) {
        case 'week1':
          this.chartDataSet(7);
          break;
        case 'month1':
          this.chartDataSet(30);
          break;
        case 'month3':
          this.chartDataSet(90);
          break;
        case 'month6':
          this.chartDataSet(180);
          break;
        case 'year1':
          this.chartDataSet(365);
          break;
        case 'year2':
          this.chartDataSet(730);
          break;
      }
    },
    chartDataSet(period) {
      // 툴팁 텍스트 삽입
      let chartTooltip = this.chartToolbarText.slice(-period);
      // 일주일 이상 데이터가 들어가면 포인트 사이즈 축소
      // 라인그래프 라벨 데이터 툴팁 삽입
      this.lineChartData.chartData.labels = this.chartLabels.slice(-period);
      this.lineChartData.chartData.datasets[0].data = this.chartData.slice(-period);
      let chartDataLength = this.lineChartData.chartData.datasets[0].data.length;
      this.lineChartData.chartData.datasets[0].pointRadius = chartDataLength <= 7 ? 3 : 1;
      if ((chartDataLength > 90 && chartDataLength <= 180) || period === 180) {
        this.chartWidth = 2330;
      } else if ((chartDataLength > 180 && chartDataLength <= 360) || period === 365) {
        this.chartWidth = 4660;
      } else if (chartDataLength > 360 || period >= 730) {
        this.chartWidth = 9320;
      } else {
        this.chartWidth = 1165;
      }
      this.lineChartData.options.tooltips.callbacks = {
        title: function () {
          return '';
        },
        label: function (tooltipItem) {
          return chartTooltip[tooltipItem.index];
        },
      };

      // 일주일 이상 데이터가 들어가면 라벨 90도로 변경
      this.barChartData.options.scales.xAxes[0].ticks.minRotation = this.lineChartData.chartData.datasets[0].data.length <= 7 ? 0 : 90;
      // 바그래프 라벨 데이터 배경 툴팁 삽입
      this.barChartData.chartData.labels = this.chartLabels.slice(-period);
      this.barChartData.chartData.datasets[0].data = this.chartData.slice(-period);
      this.barChartData.chartData.datasets[0].backgroundColor = this.chartBarColors.slice(-period);
      this.barChartData.options.tooltips.callbacks = {
        title: function () {
          return '';
        },
        label: function (tooltipItem) {
          return chartTooltip[tooltipItem.index];
        },
      };
      this.updated++;
    },
  },
};
</script>

<style scoped>
.chart_button_wrap {
  padding: 30px 30px 0;
  text-align: right;
}
.chart_button_wrap button {
  position: relative;
  width: 100px;
  height: 36px;
  font-size: 16px;
  color: #767a83;
  background-color: #fcfcfc;
  border: 1px solid #e1e2e6;
}
.chart_button_wrap button:nth-child(3) ~ button {
  width: 101px;
}
.chart_button_wrap button.active:not(:disabled) {
  z-index: 2;
  font-weight: 700;
  color: #1251fc;
  border-color: #1251fc;
  background-color: rgba(18, 81, 252, 0.06);
}
.chart_button_wrap button:disabled {
  color: #b3b3b3;
}
.chart_button_wrap button.active:disabled {
  background-color: #e1e2e6;
}
.chart_button_wrap button + button {
  margin-left: -1px;
}
.line_bar_chart_wrap {
  padding: 65px 0 25px;
  position: relative;
}
.chart_box {
  margin-left: 40px;
  margin-right: 60px;
  width: 1165px;
  overflow-x: auto;
}
.bar_chart_box {
  margin-top: 68px;
}
.chart_label_box > div:nth-child(-n + 3) {
  margin-bottom: 20px;
}
.chart_divider {
  position: absolute;
  top: 250px;
  left: 0;
  right: 0;
}
.color_box {
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 5px;
}
.color_box.blue {
  background-color: #337eff !important;
}
.color_box.green {
  background-color: #27c4aa !important;
}
.color_box.yellow {
  background-color: #fcb519 !important;
}
.color_box.red {
  background-color: #e64e81 !important;
}
.wid1020 {
  width: 1020px;
}
.wid1165 {
  width: 1165px;
}
.wid2330 {
  width: 2330px;
}
.wid4660 {
  width: 4660px;
}
.wid9320 {
  width: 9320px;
}
</style>
